import React from 'react';
import { useNavigate } from 'react-router-dom';
import './RoomPane.css';

export default function RoomPane({
  selectedRootChat,
  selectedChatChildren,
  selectedChatId,
  unreadChatIds,
  getVoicePresence,
  canCreateSubRoom,
  onOpenCreateSubRoom,
  onNavClose,
}) {
  const navigate = useNavigate();

  const handleNav = (path) => {
    navigate(path);
    onNavClose?.();
  };

  if (!selectedRootChat) {
    return (
      <div className="room-pane room-pane--empty" aria-hidden="true">
        <p className="room-pane__hint">Select a channel</p>
      </div>
    );
  }

  const allRooms = [selectedRootChat, ...selectedChatChildren];

  return (
    <nav className="room-pane" aria-label={`${selectedRootChat.name} rooms`}>
      <div className="room-pane__header">
        <span className="room-pane__channel-name">{selectedRootChat.name}</span>
      </div>

      <div className="room-pane__list">
        {allRooms.map(chat => {
          const isActive = selectedChatId === chat.id;
          const isRoot = !chat.parent_chat_id;
          const hasUnread = unreadChatIds.has(chat.id);
          const voice = getVoicePresence(chat.id);
          const route = isRoot
            ? `/channel/${chat.id}`
            : `/channel/${chat.parent_chat_id}/${chat.id}`;

          return (
            <button
              key={chat.id}
              className={`room-item${isActive ? ' room-item--active' : ''}${hasUnread ? ' room-item--unread' : ''}`}
              onClick={() => handleNav(route)}
              aria-current={isActive ? 'page' : undefined}
            >
              <span className="room-item__hash" aria-hidden="true">#</span>
              <span className="room-item__name">{chat.name}</span>
              {voice.count > 0 && (
                <span className="room-item__voice" title={`${voice.count} in voice`} aria-label={`${voice.count} in voice`}>
                  {voice.count}
                </span>
              )}
              {hasUnread && (
                <span className="room-item__unread-icon" title="Unread messages" aria-hidden="true">
                  <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
                    <path d="M9.5 1h-8a.5.5 0 0 0-.5.5v5.5a.5.5 0 0 0 .5.5H4L5.5 9 7 7.5h2.5a.5.5 0 0 0 .5-.5V1.5a.5.5 0 0 0-.5-.5Z" fill="currentColor"/>
                  </svg>
                </span>
              )}
            </button>
          );
        })}
      </div>

      {canCreateSubRoom && (
        <div className="room-pane__footer">
          <button className="room-add-btn" onClick={onOpenCreateSubRoom}>
            <span className="room-add-btn__icon" aria-hidden="true">+</span>
            Add room
          </button>
        </div>
      )}
    </nav>
  );
}
